import styled from "@emotion/styled";

const FooterWrapper = styled.footer`
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export default FooterWrapper;
